import CommonImport from "@/components/common/Import";

const InventoryImport = () => <CommonImport prop="inventory" />

export default InventoryImport